const dotenv = require('dotenv')
const dotenvExpand = require('dotenv-expand')

const myEnv = dotenv.config()
dotenvExpand(myEnv)

const apiPath = process.env.VUE_APP_API_PATH ? process.env.VUE_APP_API_PATH : '/api/backend/v1'
// const rootUrl = 'https://horeca.ihoops.uz' // process.env.NODE_ENV !== 'development' ? 'https://horeca.ihoops.uz' : 'http://localhost/horeca-api';
// const rootUrl = 'https://horeca.ihoops.uz';
const rootUrl = process.env.VUE_APP_ROOT_URL ? process.env.VUE_APP_ROOT_URL : 'https://horeca.ihoops.uz';
const socketUrl = process.env.VUE_APP_SOCKET_URL ? process.env.VUE_APP_SOCKET_URL : 'https://horeca.ihoops.uz'; // process.env.NODE_ENV !== 'development' ? 'https://horeca.ihoops.uz' : 'http://localhost:6001';
// const socketUrl = process.env.NODE_ENV !== 'development' ? 'https://horeca.ihoops.uz' : 'http://ihoops-horeca.test';

module.exports = {
    rootPath: rootUrl,
    apiUrl: rootUrl + apiPath,
    socketUrl,
    projectKey: 'AIU7LMEspeTthX2E',
    projectId: 1,
    pl: 'd-app',
    setTimeOutSec: 2000
}
